import ReactMounter from 'lib/ReactMounter'
import CareerPage from 'pages/CareerPage/CareerPage'

ReactMounter.registerComponentToMountOnLoad('CareerPage', CareerPage)
